import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RESPONSE_CODE, VALIDATOR_PATTERNS } from 'src/app/helper/class/app-constant';
import { UrlServices } from 'src/app/helper/class/url-services';
import { cloneData, isArray } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { ResponseData, formDynamicValidator } from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import { UserApiService } from 'src/app/modules/user/services/user-api.service';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { ModalService } from 'src/app/shared/service/modal.service';
import { PATIENT_LIST } from '../../helper/patient-form';
import { PatientsService } from '../../service/patients.service';
import { BsModalRef } from 'ngx-bootstrap/modal';


@Component({
  selector: 'app-add-patient',
  templateUrl: './add-patient.component.html',
  styleUrls: ['./add-patient.component.scss']
})
export class AddPatientComponent implements OnInit {
  urlService: any = UrlServices.PAGE_URL;
  dataLoading: boolean = false;
  disabled_save: boolean = false;
  basicFormData = cloneData(PATIENT_LIST);
  pageInfo: pageInfo = { title: '' }
  loader: boolean = false;
  loading: boolean = false;
  patientId: any;
  isModal: boolean = false;
  type: "NEW" | "UPDATE" = 'NEW';
  patientData: any;
  _bsModalRef: BsModalRef = {} as BsModalRef;
  dynFormData: formDynamicValidator[] = [
    {
      controlName: 'make_token',
      hideControl: ['doctor_fk_id'],
      validatorControl: [],
      value: 1,
      operation: '==',
      validator: [{ name: 'required' }]
    }
  ]
  @ViewChild('searchResult') searchResult !: TemplateRef<any>;
  @ViewChild('basicForm') basicForm: FormGeneratorComponent | undefined;
  patientNewId: any;

  constructor(
    private alertservice: AlertService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private patientApi: PatientsService,
    public formBuilder: FormBuilder,
    private modalService: ModalService,
    private dashboardService: DashboardService,
    private userApi: UserApiService,
    private injector: Injector
  ) { }

  ngOnInit(): void {
    this.patientId = this.activateRoute.snapshot.queryParams['id'] || ''
    this.type = this.activateRoute.snapshot.queryParams['type'] || '';
    this.pageInfo = {
      title: this.patientId ? 'Update Patient Details' : 'Add Patient Details',
      buttonShowBtn: true,
      button: { title: 'Patient List', url: UrlServices.PAGE_URL.PATIENT.LIST.URL, icon: 'pi pi-list' }
    }
    if (this.patientId) {
      this.getData();
    } else {
      this.getId();
    }
  }


  setInput(data) {
    this._bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    this.isModal = true;
    this.patientId = data?.id || '';
    console.log('oldId', this.patientId)
    if (this.patientId) {
      this.getData();
    } else {
      this.getId();
    }
  }
  onclose() {

  }

  apiPayload() {
    const payload = this.basicForm?.getFormValue();
    if (payload.city) {
      payload.city = typeof payload.city == 'object' ? payload.city.cityName : payload.city
    }
    if (this.patientId) {
      payload.id = this.patientId
    }
    else if (this.patientNewId) {
      payload.patient_id = this.patientNewId
    }
    console.log('payload', payload);

    return payload
  }

  getData() {
    if (!this.patientId) {
      return
    }
    this.patientApi.getDetails(this.patientId).then((res: ResponseData) => {
      console.log('res', res);

      if (res?.statusCode == RESPONSE_CODE.SUCCESS) {
        this.patientData = res?.result
        console.log('patch data', this.patientData);

        this.mapFormValue();
      }
    }).catch(err => console.log('error ', err))
  }

  getId() {
    if (this.patientNewId) {
      this.mapFormValue();
      return;
    }
    this.patientApi.getGeneratePatientId().then((res: ResponseData) => {
      if (res?.statusCode == RESPONSE_CODE.SUCCESS) {
        this.patientNewId = this.resolveGeneratedPatientId(res?.result)
        console.log('newid', this.patientNewId)
        this.mapFormValue();
      }
    }).catch(err => console.log('error ', err))
  }

  resolveGeneratedPatientId(result: any) {
    if (result && typeof result == 'object') {
      return result.patient_id || result.patientId || result.id || '';
    }
    return result;
  }

  mapFormValue() {
    if (this.patientData) {
      if (this.patientData.city) {
        this.patientData.city = this.patientData.cityName
      }
      this.patientData.medical_history_fk_id = [];
      if (isArray(this.patientData.medical_history)) {
        this.patientData.medical_history.forEach((e: any) => {
          this.patientData.medical_history_fk_id.push({ illnessName: e.illnessName, id: e.illness_fk_id })
        });
      }
      //history set
      this.basicForm?.setData(this.patientData);
    }
    if (this.patientNewId) {
      this.basicForm?.setData({ patient_id: this.patientNewId });
    }
  }

  get isFormValid() {
    return this.basicForm?.isValid();
  }

  navigateToPatientTreatmentDetails(id: any) {
    this.router.navigate([this.urlService.PATIENT.PATIENT_TREATMENT.URL], { queryParams: { id: id } })
  }

  onSubmit() {
    if (this.loading) {
      return
    }
    if (!this.isFormValid) {
      return
    }
    this.loading = true;
    const payload = this.apiPayload();
    const successMsg = this.patientId ? 'Successfully Update' : 'Successfully Saved', errorMsg = this.patientId ? 'Unable to Update' : 'Unable to Save'
    this.patientApi.savePatient(payload).then(async (res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.alertservice.showToast(successMsg, 'success')
        // this.router.navigate([UrlServices.PAGE_URL.PATIENT.LIST.URL])
        this.navigateToPatientTreatmentDetails(res.result?.id)
        if (+payload.doctor_fk_id) {
          const r = await this.dashboardService.getToken(res.result?.id, payload.doctor_fk_id).then(res => {
            this.close();
          })
        }
      } else {
        this.alertservice.showToast(errorMsg, 'error')
      }
    }).catch((err: any) => { }
    ).finally(() => { this.loading = false })
  }

  patientList: any = [];
  onChange(e: any) {

    const a = this.basicForm?.apiPayload()
    const age = a.age
    const currentDate = new Date()
    const currentYear = currentDate.getFullYear();
    const showyear = currentYear - age;
    const d = { dob: new Date(showyear, 0, 1) };
    console.log(e, 'calling')
    if (e.controlName === 'age') {
      this.basicForm?.patchValue(d);
    }
    // Duplicate mobile number check disabled: allow adding patients with an existing mobile number.
    // if (e?.controlName == 'mobile_no') {
    //   if (VALIDATOR_PATTERNS.MOBILE.test(e.value)) {
    //     //valid mobile no
    //     this.patientList = [];
    //     this.userApi.searchPatient(e.value).then((res: ResponseData) => {
    //       if (isArray(res.result)) {
    //         this.patientList = res.result;
    //         this.modalService.openModalTemplate(this.searchResult)
    //       }
    //     });
    //   }
    // }
  }

  close() {
    if (this.isModal && this._bsModalRef) {
      this._bsModalRef.hide();
      return
    }
    this.router.navigate([UrlServices.PAGE_URL.PATIENT.LIST.URL])
  }
}
